// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGas = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.334 3.453c6.25 6.5 6 12.421 6 12.421 0 3.25-1.584 5.877-4.293 6.878.67-.71 1.125-2.085 1.21-4.17.155-3.884-3.428-6.627-3.428-6.627a10.43 10.43 0 0 1-1.292 6.172c-.292-2-1.42-2.709-1.42-2.709-.164 1.125-.998 2.626-.998 2.626-1.083 2.459-.25 4.002.457 4.752a7.083 7.083 0 0 1-4.876-5.962 9.508 9.508 0 0 1 1.001-4.666c.283-.549.603-1.078.957-1.584.127-.168.25-.336.377-.542 1.474-2.002 3.919-5.839 3.874-8.839a17.941 17.941 0 0 1 2.431 2.25z"
    />
  </svg>
);
export default SvgGas;
